import { useEffect } from "react";
import {
  initializeGoogleTagManager,
  trackGoogleTagManagerPageView,
} from "@lending/lib/googleTagManager";
import { Institution } from "@lending/types";
import type { DataRouter } from "react-router";

function useLoadGoogleTagManager(
  institution: Institution,
  router: Pick<DataRouter, "state" | "subscribe">
) {
  const gtmId = institution.google_tag_manager_id;
  const whitelist = institution.google_tag_manager_whitelist;

  useEffect(() => {
    if (!gtmId || !whitelist || !initializeGoogleTagManager(gtmId, whitelist)) {
      return undefined;
    }

    // The container's own gtm.js page view covers the entry page, so only report later navigations.
    let lastPathname = router.state.location.pathname;
    return router.subscribe((state) => {
      const { pathname } = state.location;
      if (pathname === lastPathname) {
        return;
      }
      lastPathname = pathname;
      trackGoogleTagManagerPageView(pathname);
    });
  }, [gtmId, whitelist, router]);
}

export { useLoadGoogleTagManager };
